import React from 'react';
import { createPortal } from 'react-dom';
import { Button } from 'antd';
import { url } from 'libs/config';
import './index.less';

class NotFound extends React.PureComponent {
  constructor(props) {
    super(props);
    this.node = document.createElement('div');
    document.body.appendChild(this.node);
  }
  componentWillUnmount() {
    document.body.removeChild(this.node);
  }
  render() {
    return createPortal(
      <div className="page-404">
        <div className="pic-404">&nbsp;</div>
        <div className="msg-404">
          <div>
            <h1 className="tit">404</h1>
            <p className="desc">抱歉，你访问的页面不存在</p>
            <p>请尝试刷新一下浏览器</p>
            <ul className="reason">
              <li className="reason-title">可能的原因:</li>
              <li className="reason-item">1.页面缓存</li>
              <li className="reason-item">2.登录失效</li>
              <li className="reason-item">3.没有权限</li>
              <li className="reason-item">4.请求异常</li>
            </ul>
            <div>
              <Button href="/" type="primary" style={{ marginRight: 10 }}>返回首页</Button>
              <Button href={`${url.sso}/login?fr=${encodeURIComponent(window.location.href)}`} type="primary">重新登录</Button>
            </div>
          </div>
        </div>
      </div>,
      this.node
    );
  }
};

export default NotFound;
